import type * as pstUibResolversSync from "./pstUibResolversSync";
import { LazyBootModule, LazyImport } from "owa-bundling-light";

const lazyModule: LazyBootModule<typeof pstUibResolversSync> = new LazyBootModule<typeof pstUibResolversSync>(() => import(/* webpackChunkName: "PstUibResolvers" */ "./pstUibResolversSync"), {
    name: "PstUibResolvers",
});

export const lazyPstUibResolvers: LazyImport<typeof pstUibResolversSync, typeof lazyModule> = new LazyImport(lazyModule, m => m);
